//constants
import {
  BASE_GUTTER_SPACE,
  DWEB_PRIMARY_HEADER_HEIGHT,
  DWEB_SECONDARY_HEADER_HEIGHT,
  PROMO_BANNER_HEIGHT,
} from 'shared/styles/base';
export const getContainerTop = (isSubMenuVisible: boolean, showPromotionalBanner: boolean) => {
  const PROMOTIONAL_BANNER_SPACING = showPromotionalBanner
    ? BASE_GUTTER_SPACE + PROMO_BANNER_HEIGHT
    : 0;
  const containerTop = isSubMenuVisible
    ? PROMOTIONAL_BANNER_SPACING + DWEB_PRIMARY_HEADER_HEIGHT + DWEB_SECONDARY_HEADER_HEIGHT
    : PROMOTIONAL_BANNER_SPACING + DWEB_PRIMARY_HEADER_HEIGHT;
  return containerTop;
};
